import React, { Fragment } from 'react';
import {
  FormControl,
  Typography,
  MenuItem,
  Snackbar,
} from '@mui/material';
import {
  StyledCard, StyledCardTitle,
  CustomSelect,
  SectionDivider,
  SelectInputProps,
  FlexDiv
} from '../../../custom/components';
import styles from '../../../custom/style.module.css';
import docStyles from './docs.module.css';
import { Stack } from '@mui/system';
import AwbDoc from './forms/AwbDoc';
import FlightManifest from './forms/FlightManifest';
import OtherDoc from './forms/Other';
import HouseDoc from './forms/HouseDoc';

const docVerificationComponent = (props) => {

  const returnForm = (key) => {
    switch (key) {
      case 'AWB':
        return (
          <AwbDoc
            handleChangeForm={props.changeFields}
            formFields={props.formFields}
            submit={props.submit}
            docId={props.docId}
            searchAwb={props.searchAwb}
            disableButton={props.disableButton}
          />
        );
      case 'FFM':
        return <FlightManifest
          handleChangeForm={props.changeFields}
          formFields={props.formFields}
          docId={props.docId}
          submit={props.submit}
          airlines={props.airlines}
        />;
      case 'HAWB':
        return <HouseDoc
          handleChangeForm={props.changeFields}
          checkAwb={props.checkAwb}
          formFields={props.formFields}
          docId={props.docId}
          submit={props.submit}
          awbs={props.awbs}
          handleChangeAwb={props.handleChangeAwb}
        />;
      case 'OTHER':
        return <OtherDoc
          handleChangeForm={props.changeFields}
          checkAwb={props.checkAwb}
          formFields={props.formFields}
          docId={props.docId}
          submit={props.submit}
          airlines={props.airlines}
          awbs={props.awbs}
        />;
      default:
        break;
    }
  };

  const docForm = returnForm(props.docType);

  return (
    <Fragment>
      <StyledCard className={styles.h100}>
        <div className={docStyles.incomingDocHead}>
          <FlexDiv><StyledCardTitle>Verify Document</StyledCardTitle></FlexDiv>
          <Stack direction='row' justifyContent='space-between' alignItems='center' useFlexGap flexWrap='wrap'>
            <Typography variant='caption' component='label' id='doc-type-label'>Select Document Type</Typography>
            <div className={docStyles.addTextField}>
              <FormControl variant='standard' fullWidth>
                <CustomSelect
                  {...SelectInputProps}
                  labelId='doc-type-label'
                  id=''
                  name='station'
                  value={props.docType}
                  onChange={(e) => props.handleChange(e, 'docType')}
                >
                  <MenuItem value='AWB'>Airwaybill</MenuItem>
                  <MenuItem value='FFM'>Flight Manifest</MenuItem>
                  <MenuItem value='HAWB'>House Airwaybill</MenuItem>
                  <MenuItem value='OTHER'>Other</MenuItem>
                </CustomSelect>
                {/* <FormHelperText>{}</FormHelperText> */}
              </FormControl>
            </div>
          </Stack>
          <SectionDivider className={styles.my3} />
        </div>
        <div className={docStyles.verifyDocBody}>
          <div className={docStyles.px4}>
            {props.docId ? docForm : null}
          </div>
        </div>

      </StyledCard>

      <Snackbar
        open={props.openSnack}
        autoHideDuration={6000}
        onClose={props.handleSnackClose}
        message='Document verified successfully'
        ContentProps={{ className: docStyles.snackbar }}
      />
    </Fragment>
  );
};

export default docVerificationComponent;
